import { useMemo } from 'react';

import { useListPersonalVaultsAdministration, type PersonalVaultAdministration } from '@/modules/api/codegen';
import { useIsAdmin } from '@/modules/auth/hooks';
import { queryErrorMeta } from '@/modules/core/components/QueryProvider';

const NO_PERSONAL_VAULTS: PersonalVaultAdministration[] = [];

// The table is reachable by team-vault editors too, but the endpoint answers only admins.
export const usePersonalVaultsAdministration = () => {
    const isAdmin = useIsAdmin();

    const options = useMemo(() => ({ query: { enabled: isAdmin, meta: queryErrorMeta('error.vaults.fetch') } }), [isAdmin]);

    const query = useListPersonalVaultsAdministration(options);

    return { query, personalVaults: query.data?.data ?? NO_PERSONAL_VAULTS };
};
